"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _Menu = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Menu"));
var _MenuItem = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/MenuItem"));
var _lib = require("@mulesoft/exchange-react-hooks/lib");
var _exchangeUiComponents = require("@mulesoft/exchange-ui-components");
var _hooks = require("./hooks");
var _VersionsLoading = _interopRequireDefault(require("./VersionsLoading"));
var ArrowDownIcon = function ArrowDownIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.293 9.293a1 1 0 0 1 1.414 0l4.288 4.288 4.299-4.289a1 1 0 0 1 1.412 1.416l-4.299 4.29c-.781.78-2.044.78-2.824 0l-4.29-4.29a1 1 0 0 1 0-1.415z"
  }));
};
ArrowDownIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "version": "version_3x7Gef",
  "dropdown": "dropdown_IEf1IM",
  "menu-wrapper": "menu-wrapper_1Zcj1r",
  "menuWrapper": "menu-wrapper_1Zcj1r",
  "head-item": "head-item__X7rhe",
  "headItem": "head-item__X7rhe",
  "selected": "selected_2x4aem",
  "list": "list_3vejx6",
  "menu": "menu_EQ434e"
}; 
require('./VersionDropdown.css');
class DropdownOpenEvent extends CustomEvent {}
const VersionsDropdown = props => {
  const dropdownRef = _react.default.useRef();
  const handleError = (0, _lib.useErrorHandling)();
  const {
    asset: {
      groupId,
      assetId
    },
    statuses
  } = props;
  const hideStatus = (statuses === null || statuses === void 0 ? void 0 : statuses.length) === 1;
  const getAssetVersions = (0, _hooks.useGetAssetVersions)({
    groupId,
    assetId,
    statuses
  });
  const [isDropdownOpen, setIsDropdownOpen] = _react.default.useState(false);
  const [isLoading, setIsLoading] = _react.default.useState(false);
  const [selectedAsset, setSelectedAsset] = _react.default.useState(props.asset);
  const [assets, setAssets] = _react.default.useState(null);
  const loadVersions = async () => {
    let assetVersions;
    try {
      assetVersions = await getAssetVersions();
    } catch (error) {
      handleError(error);
      return;
    }
    setAssets([selectedAsset, ...assetVersions]);
    setIsLoading(false);
  };
  const handleGlobalMouseDown = _react.default.useCallback(event => {
    var _dropdownRef$current;
    const isTargetInDropdown = (_dropdownRef$current = dropdownRef.current) === null || _dropdownRef$current === void 0 ? void 0 : _dropdownRef$current.contains(event.target);
    if (!isTargetInDropdown) {
      setIsDropdownOpen(false);
    }
  }, []);
  const handleDropdownOpen = _react.default.useCallback(event => {
    if (event.detail.asset !== props.asset) {
      setIsDropdownOpen(false);
    }
  }, []);
  _react.default.useEffect(() => {
    document.addEventListener('mousedown', handleGlobalMouseDown, true);
    document.addEventListener('search-versions-dropdown-open', handleDropdownOpen);
    return () => {
      document.removeEventListener('mousedown', handleGlobalMouseDown);
      document.removeEventListener('search-versions-dropdown-open', handleDropdownOpen);
    };
  }, []);
  const handleChange = value => {
    setSelectedAsset(value);
    props.onChange(value);
  };
  const toggleDropdown = () => {
    if (!assets && !isLoading) {
      setIsLoading(true);
      loadVersions();
    }
    if (!isDropdownOpen) {
      const openEvent = new DropdownOpenEvent('search-versions-dropdown-open', {
        detail: {
          asset: props.asset
        }
      });
      document.dispatchEvent(openEvent);
    }
    setIsDropdownOpen(!isDropdownOpen);
  };
  const getPreviousIndex = () => {
    const index = assets.findIndex(asset => asset === selectedAsset);
    if (index === 0) {
      return assets.length - 1;
    }
    return index - 1;
  };
  const getNextIndex = () => {
    const index = assets.findIndex(asset => asset === selectedAsset);
    if (index === assets.length - 1) {
      return 0;
    }
    return index + 1;
  };
  const focusNextOption = getIndexFn => {
    if (!assets) {
      return;
    }
    const index = getIndexFn();
    handleChange(assets[index]);
  };
  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      toggleDropdown();
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      setIsDropdownOpen(false);
    }
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (!isDropdownOpen) {
        toggleDropdown();
        return;
      }
      let getIndexFn;
      if (event.key === 'ArrowUp') {
        getIndexFn = getPreviousIndex;
      } else if (event.key === 'ArrowDown') {
        getIndexFn = getNextIndex;
      }
      focusNextOption(getIndexFn);
    }
  };
  const renderItem = asset => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      className: styles.version,
      "data-asset-version": asset.version
    }, asset.version), !hideStatus ? /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.LifecycleStatePill, {
      status: asset.status,
      lightTheme: true
    }) : null);
  };
  if (props.disabled) {
    return renderItem(selectedAsset);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.dropdown,
    "data-test-id": "versions-dropdown",
    ref: dropdownRef,
    role: "listbox",
    onMouseDown: toggleDropdown,
    onKeyDown: handleKeyDown,
    tabIndex: 0
  }, renderItem(selectedAsset), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "xs"
  }, /*#__PURE__*/_react.default.createElement(ArrowDownIcon, null)), isDropdownOpen ? /*#__PURE__*/_react.default.createElement("div", {
    className: styles.menuWrapper
  }, /*#__PURE__*/_react.default.createElement(_Menu.default, {
    className: styles.menu
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.headItem
  }, /*#__PURE__*/_react.default.createElement("span", {
    role: "option",
    "aria-selected": true
  }, renderItem(selectedAsset)), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "xs"
  }, /*#__PURE__*/_react.default.createElement(ArrowDownIcon, null))), /*#__PURE__*/_react.default.createElement("ul", {
    className: styles.list
  }, !isLoading ? assets.map(asset => /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    className: (0, _classnames.default)({
      [styles.selected]: asset === selectedAsset
    }),
    key: asset.version,
    role: "menuitem",
    tabIndex: "-1",
    onClick: () => handleChange(asset)
  }, renderItem(asset))) : /*#__PURE__*/_react.default.createElement(_VersionsLoading.default, {
    hideStatusCell: hideStatus
  })))) : null);
};
var _default = exports.default = VersionsDropdown;
//# sourceMappingURL=VersionDropdown.js.map